const chart = {
  primary: {
    color: 'indigo.60',
    '&:active, &:focus': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'orange.45',
    '&:active, &:focus': {
      color: 'orange.60'
    },
    '&:hover': {
      color: 'orange.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.60'
    },
    '&:hover': {
      color: 'indigo.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'orange.60'
    },
    '&:hover': {
      color: 'orange.45'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    margin: 0,
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.60',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-27px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '& > p': {
      '&:hover': {
        color: 'indigo.60'
      }
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'orange.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const co = {
  primary: {
    color: 'blue.60',
    '&:active, &:focus': {
      color: 'blue.90'
    },
    '&:hover': {
      color: 'blue.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90'
    },
    '&:hover': {
      color: 'blue.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'blue.60',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-27px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '& > p': {
      '&:hover': {
        color: 'blue.90'
      }
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const edu = {
  primary: {
    color: 'indigo.70',
    '&:active, &:focus': {
      color: 'indigo.80'
    },
    '&:hover': {
      color: 'indigo.80'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80'
    },
    '&:hover': {
      color: 'indigo.70'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'indigo.70',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-23px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '& > p': {
      '&:hover': {
        color: 'indigo.60'
      }
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.80',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const scale = {
  primary: {
    color: 'primary',
    '&:active, &:focus': {
      color: 'primaryAccent'
    },
    '&:hover': {
      color: 'primaryAccent'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100'
    },
    '&:hover': {
      color: 'indigo.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primaryAccent'
    },
    '&:hover': {
      color: 'primary'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primaryAccent',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-23px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primary',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'primary',
      textDecoration: 'underline'
    },
    '& > p': {
      '&:hover': {
        color: 'primary'
      }
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'primaryAccent',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'primaryAccent',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const spark = {
  primary: {
    color: 'red.50',
    '&:active, &:focus': {
      color: 'red.80'
    },
    '&:hover': {
      color: 'red.80'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100'
    },
    '&:hover': {
      color: 'indigo.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80'
    },
    '&:hover': {
      color: 'red.50'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'red.50',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-23px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.50',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'red.50',
      textDecoration: 'underline'
    },
    '& > p': {
      '&:hover': {
        color: 'red.50'
      }
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'red.80',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const links = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark
  }
};

export type LinkVariantsType = 'primary'
| 'secondary'
| 'primaryAlternate'
| 'secondaryAlternate'
| 'navLink'
| 'subNavLink'
| 'i18nSwitcher';
export const linkVariants = Object.keys(chart) as LinkVariantsType[];

export default links;
